export default __webpack_public_path__ + "static/media/dark-side.e0f8cab7.jpg";